import React from "react";
import jardulik from "../assets/jardulik.svg";
import "./Loading.scss";

const Loading = ({ text }) => {
	return (
		<div className="loading-overlay">
			<img src={jardulik} alt="loading" className="loading-icon" />
			{text ? (
				<div className="loading-text">Загружаем админ-панель...</div>
			) : null}
		</div>
	);
};

export default Loading;
